import React, { useState, useEffect } from 'react';

const Visionn = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const sectionStyle = {
        padding: isMobile ? '0px' : '40px',
        margin: '0 auto',
    };

    const containerStyle = {
        maxWidth: isMobile ? '100%' : '1200px',
        margin: '0 auto',
        padding: '0 15px',
    };

    const rowStyle = {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'center',
        gap: '20px',
    };

    const colStyle = {
        flex: '1',
        minWidth: isMobile ? '100%' : '300px',
        boxSizing: 'border-box',
        marginBottom: isMobile ? '20px' : '0',
    };

    const headingStyle = {
        textAlign: 'center',
        paddingBottom: '20px',
        fontSize: isMobile ? '24px' : '32px',
        color: '#343a40',
    };

    const visionContentStyle = {
        backgroundColor: '#E05C35', 
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        color: 'white',
    };

    const sectionTitleStyle = {
        color: '#E05C35', // Light color for titles
    };
    const sectionTitleStylee = {
        color: 'white'
    };

    return (
        <section style={sectionStyle}>
            <div style={containerStyle}>
                <h3 style={{ ...headingStyle, ...sectionTitleStyle }}>About Our Vision & Mission</h3>
                <div style={rowStyle}>
                    <div style={colStyle}>
                        <div style={visionContentStyle}>
                            <h4 style={sectionTitleStylee}>Vision</h4>
                            <p className='text-white'>
                            At S9 Travels, our vision is to redefine travel by providing safe, efficient, and personalized transportation services. We aim to create a seamless experience, connecting travelers to their destinations with comfort and convenience. Focused on safety, customer satisfaction, and innovation, we lead the industry by integrating technology and sustainable practices. Our goal is to make travel accessible, reliable, and eco-friendly for everyone, ensuring a future where travel is easier and more enjoyable.
                            </p>
                        </div>
                    </div>
                    <div style={colStyle}>
                        <div style={visionContentStyle}>
                            <h4 style={sectionTitleStylee}>Mission</h4>
                            <p className='text-white'>
                            Our mission at S9 Travels is to deliver exceptional customer service by offering reliable and timely transportation solutions. We are committed to ensuring a safe and comfortable travel experience through comprehensive driver training and the maintenance of high-quality vehicles. By actively listening to our customers and constantly refining our services, we aim to exceed expectations at every step. Our goal is to foster long-lasting relationships with our passengers, ensuring that every journey with us is not only safe but also enjoyable and unforgettable.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Visionn;
